import BaseService from './baseService';

class Belanja extends BaseService {
	async getBelanjaByCompany(opts = {}) {
		this.endPoint = '/get-all-submission';
		return this.get(opts);
  }
	async getBelanjaUser(categoryId,opts = {}) {
    this.endPoint = '/get-submission-category/'+categoryId;
		return this.get(opts);
  }
	async getBelanjaCompany(categoryId,opts = {}) {
    this.endPoint = '/get-submission-category-company/'+categoryId;
		return this.get(opts);
  }
	async getSubmissionCategoryByName(name,opts = {}) {
    this.endPoint = '/submission-category-name/'+name;
		return this.get(opts);
  }
	async getBelanjaByUser(opts = {}) {
		this.endPoint = '/get-submission-user';
		return this.get(opts);
  }
  async createBelanja(payload){
    this.endPoint = '/submission';
    return await this.post(payload); 
  }
  async updateBelanja(id,payload,opts={}){
    this.endPoint = '/submission';
    return await this.putOne(id,payload,opts);
  }
  async updateStatusBelanja(id,payload,opts={}){
    this.endPoint = '/update-status-submission';
    return await this.putOne(id,payload,opts);
  }
  async deleteBelanja(id,opts={}){
    this.endPoint = '/submission';
    return await this.delete(id,opts);
  }
  async deleteSubmissionNoteBelanja() {
    this.endPoint = '/submission-note';
    return await this.delete(id, opts);
  }
  async filterBelanja(payload) {
    this.endPoint = '/submissions.filter';
    return await this.post(payload);
  }
}

export default new Belanja();